import React from 'react';
import cn from 'classnames';
import styles from '../QuickShopModal.module.scss';
import ScriptLoader from '../util/ScriptLoader';
import processHtml from '../util/ScriptProcessor';
const StoriesTemplate = ({ QSProduct, articleId, }) => {
    const allScripts = processHtml(QSProduct);
    return (React.createElement(React.Fragment, null,
        React.createElement(ScriptLoader, { scripts: allScripts, articleId: articleId, batchIdentifier: "scriptAbove" }),
        React.createElement("div", { id: QSProduct.querySelector('.o-quick-buy').id, className: cn('o-quick-buy', styles.QSProduct, styles.otherStories), "data-component": "OQuickBuy", "data-locale": "sv_se", "data-code-quick-buy": QSProduct
                .querySelector('.o-quick-buy')
                .getAttribute('data-code-quick-buy'), "data-articlecode": QSProduct
                .querySelector('.o-quick-buy')
                .getAttribute('data-articlecode'), "data-article-ids": QSProduct
                .querySelector('.o-quick-buy')
                .getAttribute('data-article-ids') },
            React.createElement("div", { className: cn(styles.productImage, 'm-product-image'), dangerouslySetInnerHTML: {
                    __html: QSProduct.querySelector(`.m-product-image`).innerHTML,
                } }),
            React.createElement("div", { className: cn(styles.productDetails, 'o-product-information'), "data-component": "OProductInformation" },
                React.createElement("form", { "data-component": "OForm", className: cn(styles.oForm, 'o-form add-to-cart details-section'), action: "#", method: "POST", dangerouslySetInnerHTML: {
                        __html: QSProduct.querySelector('.o-form.add-to-cart').innerHTML,
                    } })))));
};
export default StoriesTemplate;
//# sourceMappingURL=StoriesTemplate.js.map